<app-z-dialog
  [title]="'COMMON.EVENT_HISTORY' | translate"
  [contentTemplate]="contentTemplate"
></app-z-dialog>

<ng-template #contentTemplate>
  <ng-container *ngIf="history.length; else emptyData">
    <div class="timeline position-relative">
      <div *ngFor="let event of history" class="timeline-item">
        <div class="modules-panel border">
          <div class="d-flex justify-content-between background s-p-2">
            <span class="timeline-date">{{
              event.data | date : "dd/MM/yyyy HH:mm:ss"
            }}</span>
            <span class="s-me-3">
              <span class="fw-bold">Autor:</span> {{ event.usuario }}
            </span>
          </div>
          <div class="p-2">
            <p class="fw-bold">{{ event.titulo }}</p>
            <p *ngIf="event.mensagem">{{ event.mensagem }}</p>
            <p *ngIf="event.arquivoNome">
              Arquivo importado:
              <a href="{{ event.arquivoLink }}" target="_blank">{{
                event.arquivoNome
              }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #emptyData>
    <app-empty-data></app-empty-data>
  </ng-template>
</ng-template>
